export const REDIRECTS = [
  { from: '/blog/glossary-ktpn', to: '/ktpn-promo' },
  { from: '/blog/glossary-bktp', to: '/ktpn-promo' },
  { from: '/blog/ktpn-mast', to: '/ktpn-promo' },
  { from: '/catalog/ktp/25', to: '/ktpn-promo' },
  { from: '/catalog/ktp/40', to: '/ktpn-promo' },
  { from: '/catalog/ktp/63', to: '/ktpn-promo' },
  { from: '/catalog/ktp/100', to: '/ktpn-promo' },
  { from: '/catalog/ktp/160', to: '/ktpn-promo' },
  { from: '/catalog/ktp/250', to: '/ktpn-promo' },
  { from: '/blog/glossary-transformer', to: '/catalog' },
  { from: '/blog/glossary-nominal-power', to: '/blog/kak-rasschitat-moshchnost-podstantsii' },
  { from: '/blog/glossary-nominal-voltage', to: '/blog' },
  { from: '/blog/glossary-ip', to: '/blog' },
  // New redirects from nominalnoe-napryazhenie.json
  { from: '/blog/glossary-tmg', to: '/catalog/transformer' },
  { from: '/catalog/transformer/tmg-100', to: '/catalog/transformer' },
  { from: '/blog/glossary-dry-transformer', to: '/catalog/transformer' },
  { from: '/blog/glossary-kru', to: '/catalog/switchgear' },
  { from: '/blog/glossary-kso', to: '/catalog/switchgear' },
  { from: '/blog/glossary-nku', to: '/catalog/switchgear' },
  // New redirects from oil-vs-dry.json
  { from: '/blog/use-case-stroyka', to: '/projects' },
  { from: '/expert.html', to: '/about' },
  { from: '/certificates.html', to: '/about' },
  // New redirects from snt.html
  { from: '/ktpn-kiosk.html', to: '/catalog/ktp' },
  // New redirects from ktpn-kiosk.html
  { from: '/use-case-stroyka.html', to: '/projects' },
  // New redirects from ktpn-250.html
  { from: '/ktpn-160-kva.html', to: '/ktpn-promo' },
  { from: '/ktpn-400-kva.html', to: '/ktpn-promo' },
  { from: '/tmg-250-kva.html', to: '/catalog/transformer' },
  // New redirects from ktpn-160.html
  { from: '/tmg-100-kva.html', to: '/catalog/transformer' },
  // New redirects from ktpn-100.html
  { from: '/ktpn-63-kva.html', to: '/ktpn-promo' },
  // New redirects from bktp.html
  { from: '/glossary-ktpn.html', to: '/ktpn-kiosk' },
  { from: '/glossary-transformer.html', to: '/catalog/transformers' },
  { from: '/glossary-nominal-power.html', to: '/nominalnoe-napryazhenie' },
  { from: '/glossary-ip.html', to: '/blog/chto-takoe-stepen-zashchity-ip' },
  { from: '/glossary-kru.html', to: '/catalog/switchgear' },
  { from: '/glossary-nku.html', to: '/nku' },
  { from: '/ktpn-100-kva.html', to: '/ktpn-100' },
  // New redirects from nku.html
  { from: '/glossary-kru.html', to: '/catalog/switchgear' },
  { from: '/glossary-kso.html', to: '/catalog/kso' },
  { from: '/ktpn-63-kva.html', to: '/ktpn-promo' },
  // New redirects from kru.html
  { from: '/glossary-kso.html', to: '/catalog/kso' },
  { from: '/glossary-ktpn.html', to: '/ktpn-kiosk' },
  { from: '/glossary-transformer.html', to: '/catalog/transformers' },
  { from: '/glossary-ip.html', to: '/blog/chto-takoe-stepen-zashchity-ip' },
  { from: '/ktpn-100-kva.html', to: '/ktpn-100' },
];
